import React from "react";
import { useApp } from "@/context/AppContext";
import { useReveal } from "@/hooks/useReveal";

const STORY_IMG = "https://images.pexels.com/photos/8327681/pexels-photo-8327681.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const MOUNTAIN_IMG = "https://images.pexels.com/photos/8991530/pexels-photo-8991530.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const About = () => {
  const { t } = useApp();
  const ref = useReveal();

  return (
    <main ref={ref} data-testid="about-page" className="pt-32 pb-24 min-h-screen bg-[#170F09]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        {/* Hero / Geschichte */}
        <div id="geschichte" className="grid lg:grid-cols-12 gap-12 items-center mb-24 scroll-mt-28">
          <div className="lg:col-span-6 reveal">
            <div className="kicker kicker-eyebrow mb-4">{t.story.kicker}</div>
            <h1 className="section-heading text-4xl md:text-5xl lg:text-6xl mb-8">{t.story.title}</h1>
            <p className="text-white/70 leading-relaxed mb-6 text-lg">{t.story.p1}</p>
            <p className="text-white/70 leading-relaxed">{t.story.p2}</p>
          </div>
          <div className="lg:col-span-6 reveal">
            <img src={STORY_IMG} alt="Watchmaker" className="w-full h-[540px] object-cover grayscale" />
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 border-y border-white/10 py-16 mb-24 reveal">
          {[
            { l: t.story.stat1Label, v: t.story.stat1Value },
            { l: t.story.stat2Label, v: t.story.stat2Value },
            { l: t.story.stat3Label, v: t.story.stat3Value },
          ].map((s, i) => (
            <div key={i} className="text-center">
              <div className="font-heading text-6xl md:text-7xl text-[#C9A36B] mb-2">{s.v}</div>
              <div className="kicker">{s.l}</div>
            </div>
          ))}
        </div>

        {/* Quality / Über uns */}
        <div id="ueber-uns" className="mb-24 scroll-mt-28">
          <div className="max-w-3xl mb-16 reveal">
            <div className="kicker kicker-eyebrow mb-4">{t.quality.kicker}</div>
            <h2 className="section-heading text-4xl md:text-5xl">{t.quality.title}</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {t.quality.items.map((it, i) => (
              <div key={i} className="border border-white/8 p-8 reveal">
                <div className="font-mono text-4xl text-[#C9A36B]/50 mb-6">0{i + 1}</div>
                <div className="font-heading text-2xl mb-3">{it.title}</div>
                <p className="text-white/60 leading-relaxed">{it.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Mountain image */}
        <div className="relative h-[400px] overflow-hidden reveal">
          <img src={MOUNTAIN_IMG} alt="Swiss mountains" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#170F09] via-transparent to-transparent" />
          <div className="absolute bottom-8 left-8">
            <div className="kicker text-white">Zürich · Schweiz</div>
            <div className="font-heading text-3xl">Gegründet 2026</div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default About;
